import axios from 'axios';
import { clearToken, getToken } from './tokenStorage';

/**
 * Zentrale Axios-Instanz fuer alle Backend-Aufrufe.
 *
 * baseURL bleibt leer: Im Development laufen die Requests ueber den
 * CRA-Proxy (package.json "proxy" -> http://localhost:8044), im Container
 * ueber den nginx-Reverse-Proxy (/api/ -> Backend).
 */
const apiClient = axios.create({
  baseURL: '',
});

/**
 * Pfade, auf denen ein 401 NICHT zu einem harten Redirect fuehren darf:
 * - /login: sonst entstuende eine Redirect-Schleife
 * - /auth/callback: die Callback-Seite behandelt ein ungueltiges Token
 *   selbst (Navigation auf /login?error=oauth)
 * Eintraege sind normalisiert (Kleinschreibung, ohne Trailing Slash).
 */
const REDIRECT_EXEMPT_PATHS: readonly string[] = ['/login', '/auth/callback'];

/**
 * Normalisiert einen Pfad fuer den Exempt-Vergleich:
 * Kleinschreibung und Trailing Slashes entfernen ('/Login/' -> '/login').
 */
function normalizePath(path: string): string {
  const normalized = path.toLowerCase().replace(/\/+$/, '');
  return normalized === '' ? '/' : normalized;
}

// Request-Interceptor: JWT aus der sessionStorage als Bearer-Token mitsenden
apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token !== null) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response-Interceptor: 401 -> Token verwerfen und zur Login-Seite
apiClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      clearToken();
      if (!REDIRECT_EXEMPT_PATHS.includes(normalizePath(window.location.pathname))) {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
